module.exports = __webpack_public_path__ + "img/img_mobile_ui_2.739cbae0.png";